import React, { useState } from 'react';
import Select, { createFilter } from 'react-select';
import LGAS from '../../modules/lga-name-code.json';
import { colors } from '../../modules/theme.js';
const options = LGAS.map(x => ({ value: x.LGA_CODE21, label: x.LGA_NAME21 }));

const filterFn = createFilter({
  matchFrom: 'start',
});
const LGASelect = props => {
  const [textInput, setTextInput] = useState(false);
  const getOptions = () => {
    if (textInput <= 1) return [];

    return options.filter(x => filterFn(x, textInput));
  };
  return (
    <Select
      styles={{
        dropdownIndicator: defaultStyles => ({
          ...defaultStyles,
          color: colors.blue,
        }),
        input: s => ({
          ...s,
          border: 'none !important',
          background: 'none !important',
        }),
        placeholder: s => ({
          ...s,
          fontStyle: 'italic',
        }),
      }}
      value={options.find(x => x.value === props.value)}
      onChange={props.onChange}
      isClearable={true}
      options={getOptions()}
      placeholder={'Search for Local Government Area'}
      noOptionsMessage={({ inputValue }) => {
        if (inputValue.length <= 1) {
          return 'Type atleast one character to search';
        }
        return 'No Options';
      }}
      onInputChange={(inputValue, { action }) => {
        if (action !== 'input-change') return;

        setTextInput(inputValue);
      }}
    />
  );
};
export default LGASelect;
